import React from 'react';
import styles from './ScoreCards.module.css';
import { PieChart } from './PieChart';
import { PriceIndicator } from './PriceIndicator';

interface ScoreCardsProps {
  transparencia?: number; // 1-100 scale
  precio: number;
  precioMercadoMinimo?: number;
  precioMercadoPromedio?: number;
  precioMercadoMaximo?: number;
}

export const ScoreCards: React.FC<ScoreCardsProps> = ({
  transparencia,
  precio,
  precioMercadoMinimo,
  precioMercadoPromedio,
  precioMercadoMaximo
}) => {
  
  // Debug logging
  console.log('ScoreCards props:', {
    transparencia,
    precio,
    precioMercadoMinimo,
    precioMercadoPromedio,
    precioMercadoMaximo
  });
  
  return (
    <div className={styles.scoreCardsContainer}>
      {/* Transparencia Score */}
      <div className={styles.scoreCard}>
        <div className={styles.scoreHeader}>TRANSPARENCIA</div>
        <div className={styles.scoreContent}>
          <PieChart
            value={transparencia || 0}
            maxValue={100}
            color="#20B2AA" // Videntis cyan
            size={50}
          />
        </div>
        <div className={styles.scoreValuePlaceholder}></div>
      </div>

      {/* Precio de Mercado Score */}
      <div className={styles.scoreCard}>
        <div className={styles.scoreHeader}>PRECIO DE MERCADO</div>
        <div className={styles.scoreContent}>
          <PriceIndicator 
            precio={precio}
            precioMercadoMinimo={precioMercadoMinimo}
            precioMercadoPromedio={precioMercadoPromedio}
            precioMercadoMaximo={precioMercadoMaximo}
          />
        </div>
        <div className={styles.scoreValuePlaceholder}></div>
      </div>
    </div>
  );
};